import styled from 'styled-components';
import {themecolors} from "../utils/themecolors";

const Container = styled.div``;
const Text = styled.div``;
const Domain = styled.div``;

const PlaceholderLinkExcerpt = styled(({className, post}) => {
    return (
        <Container className={className}>
            <Text>
                <Domain>
                    {post?.domain || ''}
                </Domain>
            </Text>
        </Container>
    );
})`
  border: 1px solid ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_5 :themecolors.lighter_border};
  ${Text} {
    padding: 12px;
  }
  ${Domain} {
    font-size: 14px;
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text : themecolors.light_low_impact_text};
  }
`;

export default PlaceholderLinkExcerpt;
